import React from 'react';


const JobDescription = ({ description }) => {
  if (!description || description === '') {
    return <p>No description available</p>;
  }

  try {
    const cleanDescription = String(description)
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/\r\n/g, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]*>/g, '')
      .trim();

    const paragraphs = cleanDescription
      .split('\n')
      .filter(para => para.trim().length > 0);
    
    return (
      <div className="description-content">
        {paragraphs.map((paragraph, index) => (
          <p key={index} className="job-section-content">
            {paragraph.trim()}
          </p>
        ))}
      </div>
    );
  } catch (error) {
    console.error('Error rendering description:', error);
    return <p>Error displaying job description</p>;
  }
};

export default JobDescription; 